import { DocumentSignatory } from '../../../../lib/db/db.types'

type SigningInProgressProps = {
  currentSignerId?: string
  signatories: Record<string, DocumentSignatory>
  signatoryColors: Record<string, string>
}

export function SigningInProgress({
  currentSignerId,
  signatories,
  signatoryColors,
}: SigningInProgressProps) {
  return (
    <div className="space-y-4">
      <h2 className="text-lg font-semibold">Signing in progress</h2>
      <div className="space-y-2">
        {Object.values(signatories)
          .sort((a, b) => a.order - b.order)
          .map((signatory) => (
            <div
              key={signatory.id}
              className={`flex items-center gap-2 p-2 rounded ${
                signatory.id === currentSignerId ? 'bg-blue-50' : ''
              }`}
              style={{
                backgroundColor: signatoryColors[signatory.id],
              }}
            >
              <div className="flex-1">
                <p className="font-medium">{signatory.name}</p>
                <p className="text-sm text-gray-500">{signatory.email}</p>
              </div>
              <div className="text-sm">
                {signatory.status === 'signed' ? (
                  <span className="text-green-600">Signed</span>
                ) : signatory.id === currentSignerId ? (
                  <span className="text-blue-600">Waiting for signature</span>
                ) : (
                  <span className="text-gray-500">Pending</span>
                )}
              </div>
            </div>
          ))}
      </div>
    </div>
  )
}
